import React, { Component } from "react";

import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import { Link } from 'react-router-dom';


class ManagedCustomerRow extends Component {
	constructor() {
		super();
	}
	
	render() {
	return (
			<TableRow key={this.props.id}>
			<TableCell>{this.props.id}</TableCell>
			<TableCell>{this.props.name}</TableCell>
			<TableCell><Tooltip title="Remove"><Icon style={{ fontFamily: "tipoecl", fontSize: "21px", color: "#cb0c0c", cursor: "pointer"}} onClick={() => { this.props.remove(this.props.id); }}>&#59393;</Icon></Tooltip></TableCell>
			</TableRow>
		);
	}
}

export default ManagedCustomerRow;